import store from "@/store";
import { isArray } from "@/utils/validate";

/**
 * 是否可以访问目标权限元素
 * @param target 目标(路由|按钮)要求权限
 * @returns {boolean} 满足访问条件
 */
export function hasPermission(target) {
  const dyPermission = Object.keys(store.getters.dynamicPerm)
    .map((key) => store.getters.dynamicPerm[key])
    .flat(Infinity);
  if (store.getters.admin) return true;
  if (isArray(target) && target.length > 0)
    return can(
      [...store.getters.roles, ...store.getters.permission, ...dyPermission],
      {
        permission: target,
        mode: "oneOf",
      }
    );
  const { role, permission, mode = "oneOf" } = target;
  return can([mode !== "except"], {
    permission: [
      role ? can(store.getters.roles, { permission: role, mode }) : false,
      permission
        ? can([...store.getters.permission, ...dyPermission], {
            permission,
            mode,
          })
        : false,
    ],
    mode,
  });
}

/**
 * 检查是否满足权限
 * @param roleOrPermission 当前用户权限
 * @param target 目标(路由|按钮)要求权限
 * @returns {boolean} 满足访问条件
 */
function can(roleOrPermission, target) {
  let hasRole = false;
  const { permission, mode } = target;
  if (mode === "allOf")
    hasRole = permission.every((item) => roleOrPermission.includes(item));
  if (mode === "oneOf")
    hasRole = permission.some((item) => roleOrPermission.includes(item));
  if (mode === "except")
    hasRole = !permission.every((item) => roleOrPermission.includes(item));
  return hasRole;
}

export function permBtnName(permission) {
  const asyncModules = require.context("@/router/asyncRoutes", true, /\.js$/);
  let permsModules = asyncModules
    .keys()
    .map(asyncModules)
    .sort((a, b) => a.order - b.order)
    .map((item) => item.perms);
  let perms = [];
  permsModules.push(store.getters.dynamicPerm);
  this.XEUtils.arrayEach(permsModules, (module) => {
    if (module) {
      this.XEUtils.objectEach(module, (item) => {
        perms = [...perms, ...item];
      });
    }
  });
  const res = this.XEUtils.find(
    perms,
    (item) => item.permission === permission
  );
  return res ? res.title : "";
}
